import { get, patch, post, remove } from '@/api/base'

const notificationChannelsApi = {
  getAll: async companyUuid => {
    const response = await get({
      path: 'notification_channels',
      params: { company_uuid: companyUuid },
    })
    return response.success ? response.data.notification_channels : []
  },
  get: async channelUuid => {
    const response = await get({
      path: `notification_channels/${channelUuid}`,
    })
    return response.success ? response.data.notification_channel : null
  },
  create: async channelParams => {
    return await post({
      path: `notification_channels`,
      params: channelParams,
    })
  },
  update: async (channelUuid, params) => {
    const response = await patch({
      path: `notification_channels/${channelUuid}`,
      params,
    })
    return response.success ? response.data.notification_channel : null
  },
  delete: async channelUuid => {
    return await remove({
      path: `notification_channels/${channelUuid}`,
    })
  },
}

export default notificationChannelsApi
